import json2md from "json2md";
import { sanitize } from "../utils";

// custom converters
json2md.converters.image = function (input) {
    return `{% include image.html image="${input.src}" alt="${_htmlToMd(sanitize(input.alt))}" attributions="${_htmlToMd(sanitize(input.attribution))}" %}`
}
json2md.converters.quote = function (input) {
    return `{% include quote.html quote="${sanitize(input)}" %}`
}
json2md.converters.warning = function (input) {
    return `{% include warning.html title="${_htmlToMd(sanitize(input.title))}" subtitle="${_htmlToMd(sanitize(input.subtitle))}" content="${_htmlToMd(sanitize(input.content))}" %}`
}
json2md.converters.proTip = function (input) {
    return `{% include warning.html title="${_htmlToMd(sanitize(input.title))}" subtitle="${_htmlToMd(sanitize(input.subtitle))}" content="${_htmlToMd(sanitize(input.content))}" %}`
}
json2md.converters.featuredPost = function (input) {
    return `{% include featured-post.html post="${sanitize(input)}" %}`
}
json2md.converters.featuredProduct = function (input) {
    return `{% include featured-amazon-product.html title="${sanitize(input.title)}" link="${sanitize(input.link)}" description="${sanitize(input.description)}" image="${sanitize(input.imgName)}" %}`
}
json2md.converters.list_v2 = function (input) {
    let md = "";
    let type = input.style.charAt(0);
    input.items.forEach((item, index) => {
        item = item.trim();
        if (item && item.length)
            md += `\n${type == 'u' ? '-' : (index + 1 + '.')} ${item}`;
    });
    return md;
}


// pre process json blocks before sending to json2md to process
const _preProcess = (editorJson) => {
    if (!editorJson && !editorJson.blocks) return null;
    let processed = [];
    editorJson.blocks.forEach(block => {
        // skip incomplete blocks
        if (!block.data) return;

        if (block.type == "header") processed.push({ ['h' + block.data.level]: block.data.text.trim() })
        else if (block.type == "paragraph") processed.push({ 'p': _htmlToMd(block.data.text.trim()) });
        else if (block.type == "list") processed.push({ list_v2: block.data });
        else if (block.type == "image") processed.push({ image: { src: block.data.name, alt: block.data.alt, attribution: block.data.attribution } })
        else if (block.type == "quote") processed.push({ quote: _htmlToMd(block.data) })
        else if (block.type == "warning") processed.push({ warning: block.data })
        else if (block.type == "proTip") processed.push({ proTip: block.data })
        else if (block.type == "table")
            processed.push({ table: { headers: _htmlToMd(block.data.content[0]) || [], rows: _htmlToMd(block.data.content.slice(1)) || [] } })
        else if (block.type == "featuredPost") processed.push({ featuredPost: block.data.url });
        else if (block.type == "featuredProduct") processed.push({ featuredProduct: block.data });
        else if (block.type == "code") {
            processed.push({ code: { language: 'html', content: block.data.html } });
        }
    });
    return processed;
}

// convert html values to MD
const _htmlToMd = (htmlInput) => {
    if (typeof htmlInput === "string") {
        // check only for a tag
        if (!/<\/?[a, b][\s\S]*>/i.test(htmlInput)) return htmlInput.trim();
        return _htmlStrToMd(htmlInput.trim());
    }
    else if (typeof htmlInput === "object") return htmlInput.map(item => _htmlToMd(item));
}

const _htmlStrToMd = (htmlString) => {
    var el = document.createElement('div');
    el.innerHTML = htmlString;

    // supported tags: <a>, <b>
    let tags = [...el.querySelectorAll("a,b")];
    if (!tags.length) return;

    for (let i = 0; i < tags.length; i++) {
        let tag = tags[i];

        // anchor tag
        if (tag.tagName == "A") {
            let text = tag.innerHTML;
            let linkType = tag.getAttribute("data-linktype");
            let link = tag.getAttribute("href");

            if (!linkType) continue;
            let pseudoWrapper = document.createElement('pseudo-elem');
            pseudoWrapper.innerHTML = `{% include ${linkType}.html link="${link}" text="${text}" %}`;
            tags[i].parentNode.replaceChild(pseudoWrapper, tags[i]);
        }

        // bold tag
        else if (tag.tagName == "B") {
            let text = tag.innerHTML.trim();
            let pseudoWrapper = document.createElement('pseudo-elem');
            pseudoWrapper.innerHTML = `**${text}**`;
            tags[i].parentNode.replaceChild(pseudoWrapper, tags[i]);
        }
    }
    return el.innerHTML.replace('<pseudo-elem>', "").replace("</pseudo-elem>", " ");
}

export const toMarkdown = (json) => {
    let str = json2md(_preProcess(json)).replace(/\n\s*\n/g, '\n\n');
    return str;
}